module.exports = __webpack_public_path__ + "img/performing_cn.5333df1.jpg";